import React from 'react';
import PropTypes from 'prop-types';
import { Check } from 'lucide-react';
import styles from './Checkbox.module.scss';

const Checkbox = ({
  checked,
  onChange,
  disabled,
  label,
  id,
  className,
  ...rest
}) => {
  const wrapperClasses = [
    styles.wrapper,
    disabled ? styles.disabled : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <label htmlFor={id} className={wrapperClasses}>
      <span className={styles.controlWrap}>
        <input
          id={id}
          type="checkbox"
          className={styles.input}
          checked={!!checked}
          onChange={onChange}
          disabled={disabled}
          {...rest}
        />
        <span className={styles.box} aria-hidden="true">
          <Check size={14} className={styles.tick} />
        </span>
      </span>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string,
};

Checkbox.defaultProps = {
  checked: false,
  onChange: () => {},
  disabled: false,
  label: null,
  id: undefined,
  className: '',
};

export default Checkbox;
